export const generateProductSlug = (name, id, existingSlug = null) => {
  if (existingSlug) return existingSlug;
  const slug = (name || '').toString().toLowerCase().trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');
  return slug || id;
};
